import { render } from "./purchaseHistory.vue?vue&type=template&id=4b1f3854"
import script from "./purchaseHistory.vue?vue&type=script&lang=js"
export * from "./purchaseHistory.vue?vue&type=script&lang=js"

import "./purchaseHistory.vue?vue&type=style&index=0&id=4b1f3854&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__